import { isSSR } from './isSSR';

export const saveAppOsInfo = (): void => {
  const search = new URLSearchParams(location.search);

  try {
    localStorage.os_type = search.get('os_type');
    localStorage.os_version = search.get('version');
  } catch {
    //
  }
};

// TODO: Type 구체화
export const getAppOsInfo = (): {
  osType: string;
  osVersion: string;
} | null => {
  if (isSSR) {
    return null;
  }

  const search = new URLSearchParams(location.search);
  const osTypeQuery = search.get('os_type');
  const versionQuery = search.get('version');
  let osType = null;
  let osVersion = null;

  if (osTypeQuery != null) {
    osType = osTypeQuery;
    localStorage.os_type = osTypeQuery;
  } else {
    osType = localStorage.os_type;
  }
  if (versionQuery != null) {
    osVersion = versionQuery;
    localStorage.os_version = versionQuery;
  } else {
    osVersion = localStorage.os_version;
  }

  return {
    osType,
    osVersion,
  };
};
